// Define a map of activities to their respective time options
const activityTimeMap = {
  push: "minTime30",
  pull: "minTime30",
  legs: "minTime30",
  arms: "minTime30",
  calisthenics: "minTime30",
  shoulders: "minTime15",
  core: "minTimeCore",
  stretch: "minTimeStretch",
  cardio: "minTime5",
  fullbody: "minTime45",
};

// Time intervals for different activities
const timeOptions = {
  minTime30: {
    30: "30 min",
    45: "45 min",
    60: "60 min",
    75: "75 min",
    90: "90 min",
  },
  minTime15: {
    15: "15 min",
    30: "30 min",
    45: "45 min",
    60: "60 min",
    75: "75 min",
    90: "90 min",
  },
  minTime10: {
    10: "10 min",
    20: "20 min",
    30: "30 min",
    45: "45 min",
    60: "60 min",
    90: "90 min",
  },
  minTimeStretch: {
    10: "10 min",
    20: "20 min",
    30: "30 min",
  },
  minTimeCore: {
    15: "15 min",
    30: "30 min",
    45: "45 min",
  },
  minTime5: {
    5: "5 min",
    15: "15 min",
    30: "30 min",
    45: "45 min",
    60: "60 min",
    90: "90 min",
  },
  minTime45: {
    45: "45 min",
    60: "60 min",
    75: "75 min",
    90: "90 min",
    105: "105 min",
    120: "120 min",
  },
};

const defaultOption = "minTime30";

// Function to generate time options based on the activity type
export const generateTimeOptions = (activity) => {
  const timeKey = activityTimeMap[activity] || defaultOption;
  if (timeKey) {
    return timeOptions[timeKey];
  } else {
    // Provide a default or return an error
    console.error("Invalid activity specified");
    return timeOptions[defaultOption];
  }
};
